// extracted by mini-css-extract-plugin
export default {"cati":"cati_cati__ToEx-","container":"cati_container__9q1VN","content":"cati_content__wjoLG","flexb":"cati_flexb__VD+XL"};